import permissionMessages from
  'ringcentral-integration/modules/RolesAndPermissions/permissionsMessages';

export default {
  [permissionMessages.invalidTier]: 'La tua versione non supporta l\'integrazione {application}. Contatta il rappresentante dell\'account per aggiornare la versione {brand}.',
};
